import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import FileUploader from './components/FileUploader';
import FileExplorer from './components/FileExplorer';
import TextOutput from './components/TextOutput';
import Header from './components/Header';
import './App.css';

function App() {
  const [files, setFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(new Set());
  const [textOutput, setTextOutput] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const handleFilesExtracted = (extractedFiles) => {
    setFiles(extractedFiles);
    setSelectedFiles(new Set(extractedFiles.map(f => f.path)));
  };

  const handleFileSelection = (filePath, isSelected) => {
    setSelectedFiles(prev => {
      const newSet = new Set(prev);
      if (isSelected) {
        newSet.add(filePath);
      } else {
        newSet.delete(filePath);
      }
      return newSet;
    });
  };

  const generateTextOutput = () => {
    setIsProcessing(true);
    
    setTimeout(() => {
      const selectedFileObjects = files.filter(f => selectedFiles.has(f.path));
      
      let output = `Code Files Analysis\n`;
      output += `Generated on: ${new Date().toLocaleString()}\n`;
      output += `Total files: ${selectedFileObjects.length}\n`;
      output += `${'='.repeat(50)}\n\n`;

      selectedFileObjects.forEach((file, index) => {
        output += `File ${index + 1}: ${file.path}\n`;
        output += `Size: ${file.size} bytes\n`;
        output += `Type: ${file.type || 'Unknown'}\n`;
        output += `${'-'.repeat(30)}\n`;
        output += `${file.content}\n`;
        output += `\n${'='.repeat(50)}\n\n`;
      });

      setTextOutput(output);
      setIsProcessing(false);
    }, 500);
  };

  const resetAll = () => {
    setFiles([]);
    setSelectedFiles(new Set());
    setTextOutput('');
  };

  const backToHome = () => {
    resetAll();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <Header 
        showBackButton={files.length > 0} 
        onBackToHome={backToHome} 
      />
      
      <main className="container mx-auto px-4 py-8 space-y-8">
        <AnimatePresence mode="wait">
          {files.length === 0 ? (
            <motion.div
              key="uploader"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="max-w-2xl mx-auto"
            >
              <FileUploader onFilesExtracted={handleFilesExtracted} />
            </motion.div>
          ) : (
            <motion.div
              key="explorer"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="grid grid-cols-1 lg:grid-cols-2 gap-8"
            >
              <div className="space-y-6">
                <FileExplorer
                  files={files}
                  selectedFiles={selectedFiles}
                  onFileSelection={handleFileSelection}
                  onGenerateText={generateTextOutput}
                  onReset={resetAll}
                  isProcessing={isProcessing}
                />
              </div>
              
              <div>
                <TextOutput 
                  content={textOutput} 
                  isProcessing={isProcessing}
                />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </main>
    </div>
  );
}

export default App;